import React from "react";
import "./DesignWhyChoose.css";
import {
  FiAward,
  FiClock,
  FiLayers,
  FiRepeat,
  FiUsers,
  FiTrendingUp,
} from "react-icons/fi";

const DesignWhyChoose = () => {
  return (
    <section className="oglitz-design-packages-why">
      {/* Decorative background */}
      <div className="oglitz-design-packages-why__bg-glow" />

      <div className="oglitz-design-packages-why__container">
        {/* Header */}
        <div className="oglitz-design-packages-why__header">
          <span className="oglitz-design-packages-why__badge">
            Why Choose Oglitz
          </span>

          <h2 className="oglitz-design-packages-why__title">
            Premium Design Packages
            <br />
            <span className="oglitz-design-packages-why__title-accent">
              Built for Brands That Want to Win
            </span>
          </h2>

          <p className="oglitz-design-packages-why__subtitle">
            We combine strategy, creativity, and execution to deliver designs
            that don’t just look good — they perform.
          </p>
        </div>

        {/* Cards */}
        <div className="oglitz-design-packages-why__grid">
          {[
            {
              icon: <FiAward />,
              title: "Brand-First Strategy",
              desc: "Every design decision is driven by brand positioning, audience psychology, and long-term vision.",
            },
            {
              icon: <FiClock />,
              title: "Fast, Reliable Delivery",
              desc: "Streamlined workflows ensure speed without sacrificing quality or attention to detail.",
            },
            {
              icon: <FiRepeat />,
              title: "Iterative Refinement",
              desc: "We refine and improve designs until they align perfectly with your expectations.",
            },
            {
              icon: <FiLayers />,
              title: "Scalable Design Systems",
              desc: "Not just assets — we deliver reusable, consistent design systems.",
            },
            {
              icon: <FiUsers />,
              title: "Dedicated Design Team",
              desc: "Direct collaboration with designers and managers for clarity and speed.",
            },
            {
              icon: <FiTrendingUp />,
              title: "Designed for Growth",
              desc: "Our designs evolve with your business — from startup to enterprise.",
            },
          ].map((item, index) => (
            <div key={index} className="oglitz-design-packages-why__card">
              <div className="oglitz-design-packages-why__icon-wrap">
                {item.icon}
              </div>
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default DesignWhyChoose;
